import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineNullCell } from "../../../../../mantine/mrt/components/cell/MantineNullCell";
import { getDateColumn } from "../../../../../mantine/mrt/components/columns/getDateColumn";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { DATE_DISPLAY_FORMAT } from "../../../../../utils/dates/dates.constants";
import type { Paragraph6FinancialDocument } from "../../../Paragraph6.types";

function getCreationDateColumn(): MRT_ColumnDef<Paragraph6FinancialDocument> {
  return getDateColumn({
    key: "creation_date",
    options: {
      header: "Erstellungsdatum",
      size: 200,
      filterVariant: "date-range",
      filterFn: (row, columnId, filterValue: [Date | null, Date | null]) => {
        // MRT's built-in date-range filter doesn't handle undefined; unpaid rows have an empty string -> value undefined
        const value = row.getValue<Date>(columnId);
        const [start, end] = [
          filterValue[0] ? new Date(filterValue[0]) : null,
          filterValue[1] ? new Date(filterValue[1]) : null
        ];

        if (!start && !end) return true;
        if (value === undefined) return false;
        if (start && value < start) return false;
        if (end && value > end) return false;
        return true;
      },
      Cell: ({ row }) => {
        if (!row.original.creation_date) {
          return <MantineNullCell />;
        }
        return backendDateOrDateTimeToLuxonDateTime(
          row.original.creation_date
        ).toFormat(DATE_DISPLAY_FORMAT);
      }
    }
  });
}

export { getCreationDateColumn };
